import FetchService from "./Shared/FetchService";
const advisorURL = "/aviso/advisor";
export default class TermBasedSuccesScoringService {
    static getScoreReasons(affiliationId) {
        return FetchService.getSingleResponse(advisorURL + "/getPersistenceSuccessScoreReasons", { affiliationId });
    }
}
